import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "min-h-screen flex flex-col items-center justify-center p-5 bg-primary30" }
const _hoisted_2 = {
  key: 0,
  class: "w-full bg-[#FEF9E7] border-[#F1C21B] p-3 text-center text-sm text-textPrimary flex justify-center items-center gap-4 fixed top-0 z-50"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-left inter" }, "Para médicos, acesse o Minha Escala através do aplicativo", -1)
const _hoisted_4 = { class: "mb-12" }
const _hoisted_5 = { class: "w-full flex justify-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", { class: "font-inter font-bold text-lg leading-7 text-[#333333] mb-8 text-center" }, " Login ", -1)
const _hoisted_7 = { class: "w-full" }
const _hoisted_8 = { "data-testid": "signin-email-input" }
const _hoisted_9 = { "data-testid": "signin-password-input" }
const _hoisted_10 = { class: "w-full flex flex-col gap-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Logo = _resolveComponent("Logo")!
  const _component_GenericInput = _resolveComponent("GenericInput")!
  const _component_PasswordInput = _resolveComponent("PasswordInput")!
  const _component_GhostButton = _resolveComponent("GhostButton")!
  const _component_FilledButton = _resolveComponent("FilledButton")!
  const _component_OutlineButton = _resolveComponent("OutlineButton")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isMobileDevice)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openApp && _ctx.openApp(...args))),
            class: "bg-primary30 text-white font-bold py-1 px-4 rounded w-40"
          }, " Abrir app "),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isMobileDevice = false)),
            class: "font-bold text-lg"
          }, "×")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Logo, {
        width: "160px",
        logo: "full_text_white"
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_v_form, {
        onSubmit: _withModifiers(_ctx.submitLogin, ["prevent"]),
        "fast-fail": false,
        class: "w-full max-w-md bg-white rounded shadow-lg p-10 flex flex-col items-center",
        ref: "elLoginForm"
      }, {
        default: _withCtx(() => [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_GenericInput, {
                type: "email",
                label: "Email",
                modelValue: _ctx.loginForm.values.email,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.loginForm.values.email) = $event)),
                onValidate: _cache[3] || (_cache[3] = ($event: any) => (_ctx.validate('email'))),
                rules: [_ctx.rules.email]
              }, null, 8, ["modelValue", "rules"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_PasswordInput, {
                modelValue: _ctx.loginForm.values.password,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.loginForm.values.password) = $event)),
                onValidate: _cache[5] || (_cache[5] = ($event: any) => (_ctx.validate('password'))),
                rules: [_ctx.rules.password]
              }, null, 8, ["modelValue", "rules"])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_GhostButton, {
              text: "Esqueci minha senha",
              to: "/forgot-password",
              width: "100%"
            }),
            _createVNode(_component_FilledButton, {
              text: "Entrar",
              type: "submit",
              width: "100%",
              disabled: _ctx.isLoading,
              loading: _ctx.isLoading,
              "data-testid": "signin-submit-btn"
            }, null, 8, ["disabled", "loading"]),
            (_ctx.enabledSignup)
              ? (_openBlock(), _createBlock(_component_OutlineButton, {
                  key: 0,
                  text: "Registrar",
                  to: "/signup",
                  width: "100%",
                  "data-testid": "signin-signup-btn"
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ])
  ]))
}